<template>
  <dl class="row mb-0">
    <template v-for="field in fields">
      <dt :key="`${field.key}-label`" class="col-5">{{ field.label }}</dt>
      <dd :key="field.key" class="col-7">{{ displayValue(field.key) }}</dd>
    </template>
  </dl>
</template>

<script>
export default {
  name: 'HorseMergeProfile',
  props: {
    horse: { type: Object, required: true }
  },
  data() {
    return {
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name' },
        { key: 'owner', label: 'Owner' },
        { key: 'gender', label: 'Sex' },
        { key: 'dob', label: 'Date of birth' },
        { key: 'registration_date', label: 'Registered' },
        { key: 'ashs_number', label: 'ASHS#' },
        { key: 'aqhs_number', label: 'AQHA#' },
        { key: 'sire_id', label: 'Sire ID' },
        { key: 'dam_id', label: 'Dam ID' },
        { key: 'historic_point_ach', label: 'Historic ACH' },
        { key: 'historic_point_rom', label: 'Historic ROM' }
      ]
    }
  },
  methods: {
    displayValue(key) {
      const value = this.horse[key]
      return value !== null && value !== '' ? value : '—'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Horses/HorseMergeProfile.vue